import {
  Allowance,
  OverlappingEmpForm,
} from '~/features/OverlappingEmploymentDialog/hooks/useOverlappingEmploymentForm';

import {
  AllowanceSubmitData,
  submitAllowanceProposal,
} from '../../../scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/AllowanceProposalForm/data';

const mapOverlappingFormToBenefitProposalPayload = (
  employmentId: number,
  allowance: Allowance,
  loginId: number,
  isHR: boolean,
): AllowanceSubmitData => {
  const {
    fAllowanceProposalAmount,
    fAllowanceProposalTaxableAmount,
    ...allowanceRest
  } = allowance;

  return {
    ...allowanceRest,
    fAllowanceProposalAmount: fAllowanceProposalAmount?.toString() ?? '',
    fAllowanceProposalTaxableAmount:
      fAllowanceProposalTaxableAmount?.toString() ?? '',
    fEmplId: employmentId,
    fAllowanceProposalStatus: isHR ? 'HR_APPROVED' : 'PROPOSED',
    fAllowanceProposalHrId: isHR ? loginId : -1,
    fAllowanceProposalManagerId: isHR ? -1 : loginId,
    fAllowanceProposalHigherMgrId: -1,
  };
};

export const saveAllowanceProposal = async (
  employeeId: number,
  employmentId: number,
  form: OverlappingEmpForm,
  loginId: number,
  isHR: boolean,
) => {
  return Promise.all(
    form.overlappingEmployment.allowance.map((allowance) => {
      return submitAllowanceProposal(
        mapOverlappingFormToBenefitProposalPayload(
          employmentId,
          allowance,
          loginId,
          isHR,
        ),
        { employeeId, employmentId },
      ).catch((e) => {
        console.log('saveAllowanceProposal', e);
      });
    }),
  );
};
